import styled from 'styled-components';

export default styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const ResultHeadlineSC = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0px;
`;

export const FaqLinkSC = styled.a`
  cursor: pointer;
  font-size: 16px;
  font-weight: normal;
  padding: 10px 0;
  width: 100%;
  border-bottom: 1px solid #e9e9e9;
  text-decoration: none;
  &:hover {
    border-bottom: 1px solid #8e885b;
    transition: all 0.3s;
  }
`;
